import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import { formatMinutes } from '../utils/timeFormat';

const TICK_MS = 30 * 1000;

// Shows how long a table has been running, or when it stopped once it is empty.
// A table "runs" from the first player sitting down until the last one leaves.
const TableTimer = ({ runningSince, lastStoppedAt, lastRunMinutes }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!runningSince) return undefined;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(id);
  }, [runningSince]);

  let dot = 'var(--cm-text-faint)';
  let primary = 'Not started yet';
  let secondary = null;

  if (runningSince) {
    const elapsed = (now - new Date(runningSince).getTime()) / 60000;
    dot = 'var(--cm-success)';
    primary = `Running ${formatMinutes(elapsed)}`;
    secondary = `Started ${moment(runningSince).format('hh:mm A')}`;
  } else if (lastStoppedAt) {
    dot = 'var(--cm-danger)';
    primary = `Stopped ${moment(lastStoppedAt).format('hh:mm A')}`;
    secondary = `Ran ${formatMinutes(lastRunMinutes)}`;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: dot, flexShrink: 0 }} />
      <Typography sx={{ color: 'white', fontSize: 12, fontWeight: 600 }}>{primary}</Typography>
      {secondary && (
        <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 11 }}>{secondary}</Typography>
      )}
    </Box>
  );
};

export default TableTimer;
